module.exports = __webpack_public_path__ + "static/media/cases_web_keslon_06b.7395eaa6.jpg";